import { createCompany } from '@/redux/requests/companiesRequests.js';
import switchOrganization from './switchOrganization.js';

/** Creates an organization owned by the signed-in person and moves the session into it. */
const createOrganization = ({ name, ownerId }) => {
  return async (dispatch) => {
    const createRes = await createCompany({ name, ownerId });
    const companyId = createRes?.data?.activeCompanyId || null;

    if (createRes?.success === false || !companyId) {
      return { success: false, message: createRes?.message || 'The organization could not be created.' };
    }

    return dispatch(switchOrganization({ companyId }));
  };
};

export default createOrganization;
